<template>
  <el-drawer :append-to-body="true" size="80%" :visible.sync="show" :title="title" @closed="$emit('closed');">
      <el-autocomplete
        v-model="searchedProduct"
        :fetch-suggestions="querySearchAsync"
        style="width: 100%"
        placeholder="Enter item's article or name..."
        @select="handleSelect"
      >
        <template slot-scope="{ item }">
          <span style="float: left">
            {{ item.name }}
            <span v-show="item.sku">(Article {{ item.sku }})</span>
          </span>
          <span style="float: right; color: #8492a6; font-size: 13px">{{ item.price }} AED</span>
        </template>
      </el-autocomplete>
    </el-drawer>
</template>

<script>
import order from "../api/order";

export default {
  props: {
    show: Boolean,
    title: String,
    guid: String,
    index: Number,
    orderID: Number
  },
  data() {
    return {
      searchedProduct: ""
    }
  },
  methods: {
    handleSelect(item) {
      order.addPosition(this.orderID, this.guid, this.index, item.guid);
      this.$emit('addedPosition');
    },
    async querySearchAsync(queryString, cb) {
      let response = await order.findProduct(queryString);
      cb(response.data.data);
    }
  }
}
</script>

<style>

</style>
